import { request, METHOD } from '@/utils/request';
var BASE_URL = process.env.VUE_APP_API_BASE_URL;

/**
 *【#344】获取移动端分类页面树型结构一级分类名称
 */
export function getLeftcategoryList() {
  return request("".concat(BASE_URL) + "/classify/setting/levelOneList", METHOD.GET);
}

/**
 * 【#345】获取一级分类或一级分类下的二级分类列表
 */
export function getRightcategoryList(id, params) {
  return request("".concat(BASE_URL) + "/classify/setting/customSubList/" + id, METHOD.GET, params);
}

/**
 * 【#346】获取移动端分类页面一级分类信息（编辑时用)
 */
export function getCategoryDetail(id) {
  return request("".concat(BASE_URL) + "/classify/setting/levelOneInfo/" + id, METHOD.GET);
}

/**
 * 【#347】一级分类和自定义类型的二级分类列表排序 
 */
export function sortOrder(type, data) {
  return request("".concat(BASE_URL) + "/classify/setting/sortOrder?flag=" + type, METHOD.PUT, data);
}

/**
 * 【#349】修改一级分类
 */
export function editFirstcategory(id, data) {
  return request("".concat(BASE_URL) + "/classify/setting/editLevelOne/" + id, METHOD.PUT, data);
}

/**
【#348】添加一级分类
*/
export function addFirstcategory(data) {
  return request("".concat(BASE_URL) + "/classify/setting/addLevelOne", METHOD.POST, data);
}

/**
* 【#350】删除一级分类 
*/
export function deleteFirstcategory(id) {
  return request("".concat(BASE_URL) + "/classify/setting/del/" + id, METHOD.DELETE);
}

/**
 * 【#346】获取移动端分类页面二级分类信息（编辑时用）
 */
export function getSecondCategoryDetail(id) {
  return request("".concat(BASE_URL) + "/classify/setting/levelTwoInfo/" + id, METHOD.GET);
}

/**
* 【#351】添加自定义类型的二级分类 
*/
export function addSecondcategory(parentId, data) {
  return request("".concat(BASE_URL) + "/classify/setting/addCustomLevelTwo/" + parentId, METHOD.POST, data);
}

/**
【#352】修改自定义类型的二级分类
*/
export function editSecondCategory(id, data) {
  return request("".concat(BASE_URL) + "/classify/setting/editCustomLevelTwo/" + id, METHOD.PUT, data);
}

/**
 * 【#353】删除自定义类型的二级分类
 */
export function deleteSecondcategory(id) {
  return request("".concat(BASE_URL) + "/classify/setting/delSub/" + id, METHOD.DELETE);
}

/* 获取一级分类列表 不受商品分类显示与否控制*/
export function getCategoryIdAndNameList() {
  return request("".concat(BASE_URL) + "/product/category/onlyIdAndName/list?isMobileClassify=1", METHOD.GET);
}